module.exports = __webpack_public_path__ + "static/img/title.227cf8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/feature/title.png
// module id = tCYx
// module chunks = 7